import { GetApp } from "../../App"
import { GetShip } from "../../App/Context"
import { BlockRow } from "../../Components/Block"
import { INoteType } from "../../Types"
import { dayToDate } from "../DayView"
import { NoteAttachmentsData } from "../Note/Attachments"
import { PrintJournalViewProps } from "./Params"

export function PrintJournalView({ cruise: _cruise, day, note, trip }: PrintJournalViewProps) {
  const app = GetApp();
  const ship = GetShip();
  const tc = app.getT("PrintView");

  if (note.noteType !== INoteType.journal) {
    return null;
  }

  const attachments = (note.attachments || []).map((a) => {
    const key = `note-${note.id}-attachment-${a.id}`;
    const _label = <span className="attachment-label">{a.fileName}.{a.fileType}</span>;
    const image = NoteAttachmentsData.isImage(a);
    const url = NoteAttachmentsData.attachmentUrl(app.apiClient, ship.id, note.id, a, app.cloudSession());
    return (
      <a key={key} href={url} className="attachment" target="_blank" rel="noopener noreferrer">
        {image && <img src={url} />}
      </a>
    );
  });

  return (
    <>
      <h4>
        {note.tripId != undefined && note.dayId == null && trip && ` ${tc("trip")} – ${trip.title}`}
        {note.dayId != undefined && day && `${app.format("date", dayToDate(day.day).toISOString())}`}
      </h4>
      <h5>{note.title}</h5>
      <BlockRow className="print-note-text ">
        {note.note}
      </BlockRow>
      <BlockRow className="attachments print-attachments">
        {attachments}
      </BlockRow>
    </>
  );
}
